import type { LinkMouseEvent } from "./types";

import { useSegmentAnalytics } from "./useSegmentAnalytics";

export const useOverviewPageAnalytics = () => {
  const { trackButtonClickEvent, trackLinkClickEvent, trackHoverEvent } =
    useSegmentAnalytics();

  const trackJoinNowIBProgramEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({
      event,
      label: "Join now",
      location: "Overview IB program",
    });
  const trackJoinNowAffiliatesEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({
      event,
      label: "Join now",
      location: "Overview affiliates",
    });

  const trackCompleteApplicationIncompleteBannerEvent = (
    event: LinkMouseEvent,
  ) =>
    trackLinkClickEvent({
      event,
      label: "Complete application",
      location: "Overview incomplete application banner",
    });
  const trackCompleteApplicationReferralLinkEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({
      event,
      label: "Complete application",
      location: "Overview referral link banner",
    });
  const trackReferralCopyCodeEvent = () =>
    trackButtonClickEvent({
      label: "Copy link",
      location: "Overview complete referral link",
    });

  const trackReferralWidgetViewAllLinksEvent = () =>
    trackButtonClickEvent({
      label: "Overview page - Referral widget - View all links",
      location: "Overview - Referral widget",
      extraProperties: {
        event_type: "Click",
        link_text: "Overview page - Referral widget - View all links",
      },
    });

  const trackReferralWidgetCopyEvent = () =>
    trackButtonClickEvent({
      label: "Overview page - Referral widget - Copy",
      location: "Overview - Referral widget",
      extraProperties: {
        event_type: "Click",
        link_text: "Overview page - Referral widget - Copy",
      },
    });

  const trackReferralWidgetReferralLinkEvent = () =>
    trackButtonClickEvent({
      label: "Overview page - Referral widget - Referral link",
      location: "Overview - Referral widget",
      extraProperties: {
        event_type: "Click",
        link_text: "Overview page - Referral widget - Referral link",
      },
    });

  const trackReferralWidgetLinkToggleEvent = () =>
    trackButtonClickEvent({
      label: "Overview page - Referral widget - Link toggle",
      location: "Overview - Referral widget",
      extraProperties: {
        event_type: "Click",
        link_text: "Overview page - Referral widget - Link toggle",
      },
    });

  const trackReferralWidgetViewQRCodeEvent = () =>
    trackButtonClickEvent({
      label: "Overview page - Referral widget - View QR code",
      location: "Overview - Referral widget",
      extraProperties: {
        event_type: "Click",
        link_text: "Overview page - Referral widget - View QR code",
      },
    });

  const trackReferralWidgetDownloadQRCodeEvent = () =>
    trackButtonClickEvent({
      label:
        "Overview page - Referral widget - View QR code - Download QR code button",
      location: "Overview - Referral widget - View QR code",
      extraProperties: {
        event_type: "Click",
        link_text:
          "Overview page - Referral widget - View QR code - Download QR code button",
      },
    });

  const trackGoToLeadsEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({
      event,
      label: "Recent leads",
      location: "Overview page",
    });

  const trackGoToTopEarnersEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({
      event,
      label: "Top earners",
      location: "Overview page",
    });

  const trackRecentLeadStatusTooltipEvent = (
    status: string,
    isMobile: boolean,
  ) => {
    if (isMobile) {
      trackButtonClickEvent({
        label: "Tool tip bubble",
        location: "Overview",
        extraProperties: {
          status,
          link_text: "Tool tip icon",
        },
      });
    } else {
      trackHoverEvent({
        label: "Tool tip modal",
        location: "Overview",
        extraProperties: { status },
      });
    }
  };

  const trackOverviewTooltipEvent = (isMobile: boolean) => {
    if (isMobile) {
      trackButtonClickEvent({
        label: "Tool tip modal",
        location: "Overview",
        extraProperties: {
          link_text: "Tool tip icon",
        },
      });
    } else {
      trackHoverEvent({
        label: "Tool tip bubble",
        location: "Overview",
        extraProperties: {
          link_text: "Tool tip icon",
        },
      });
    }
  };

  return {
    trackJoinNowIBProgramEvent,
    trackJoinNowAffiliatesEvent,
    trackCompleteApplicationIncompleteBannerEvent,
    trackCompleteApplicationReferralLinkEvent,
    trackReferralCopyCodeEvent,
    trackGoToLeadsEvent,
    trackGoToTopEarnersEvent,
    trackRecentLeadStatusTooltipEvent,
    trackOverviewTooltipEvent,
    trackReferralWidgetViewAllLinksEvent,
    trackReferralWidgetCopyEvent,
    trackReferralWidgetReferralLinkEvent,
    trackReferralWidgetLinkToggleEvent,
    trackReferralWidgetViewQRCodeEvent,
    trackReferralWidgetDownloadQRCodeEvent,
  };
};
